import React from 'react';
import { useNavigate } from 'react-router-dom';
import ServerForm from './ServerForm';

const CreateServer: React.FC = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('/');
  };

  const handleCancel = () => {
    navigate('/');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <ServerForm onSuccess={handleSuccess} onCancel={handleCancel} />
    </div>
  );
};

export default CreateServer;
